import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CountricsPage } from './countrics.page';

const routes: Routes = [
  {
    path: '',
    component: CountricsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CountricsPageRoutingModule {}
